import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import { GiftCardPaymentStatus } from 'shared/models'
import { paymentStatusText } from './status-utils'
import { adminService } from 'shared/api'

function GiftCardPaymentStatusDialog({
  giftCardId,
  initialStatus,
  onClose,
  open
}: {
  giftCardId: number
  initialStatus: GiftCardPaymentStatus
  open: boolean
  onClose: () => void
}) {
  const [status, setStatus] = useState(initialStatus)
  const [processing, setProcessing] = useState(false)

  useEffect(() => {
    if (open === true) {
      setStatus(initialStatus)
    }
  }, [open])

  async function handleStatusSave() {
    setProcessing(true)

    try {
      await adminService.giftCard.changePaymentStatus(giftCardId, status)
    } finally {
      setProcessing(false)
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Статус оплаты</DialogTitle>
      <DialogContent>
        <Select
          value={status}
          onChange={(ev) => {
            setStatus(ev.target.value as GiftCardPaymentStatus)
          }}
          fullWidth
          variant="standard"
          size="small"
        >
          {Object.keys(GiftCardPaymentStatus)
            .filter((s) => s !== 'None')
            .map((key) => (
              <MenuItem key={key} value={key}>
                {paymentStatusText[key]}
              </MenuItem>
            ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button type="submit" variant="outlined" disabled={processing} onClick={handleStatusSave}>
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export { GiftCardPaymentStatusDialog }
